import selectNodeInFolderForest from './selectNodeInFolderForest';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import { folderForestStore, getSelectedNode } from 'owa-mail-folder-forest-store';
import { GroupFolderForestNode, FolderForestNodeType } from 'owa-favorites-types';
import { FolderForestTreeType } from 'owa-graph-schema';
import { action } from 'satcheljs/lib/legacy';
import { lazySelectGroup } from '../lazyFunctions';
import { GROUPS_FOLDERS_TREE_TYPE } from 'owa-folders-constants';

export interface SelectGroupFolderState {
    selectedNode: GroupFolderForestNode;
}

/**
 * General select group folder action
 * @param groupId the groupId
 * @param groupFolderId the group folder id
 * @param treeType the type of folder tree
 */
const selectGroupFolderInternal = action('selectGroupFolderInternal')(
    function selectGroupFolderInternal(
        groupId: string,
        groupFolderId: string,
        treeType: FolderForestTreeType
    ): Promise<void> {
        return selectNodeInFolderForest(<GroupFolderForestNode>{
            id: groupFolderId,
            type: FolderForestNodeType.GroupFolder,
            treeType: treeType,
            groupId: groupId,
        });
    }
);

/**
 * Select a group folder
 * @param groupId the groupId
 * @param groupFolderId the group folder Id
 * @param treeType the type of folder tree
 */
export default action('selectGroupFolder')(async function selectGroupFolder(
    groupId: string,
    groupFolderId: string,
    treeType: FolderForestTreeType,
    state: SelectGroupFolderState = {
        selectedNode: folderForestStore.selectedNode as GroupFolderForestNode,
    }
) {
    const currentNode = getSelectedNode() as GroupFolderForestNode;
    if (
        currentNode.type === FolderForestNodeType.GroupFolder &&
        currentNode.groupId &&
        currentNode.groupId.toLowerCase() === groupId.toLowerCase() &&
        currentNode.id &&
        currentNode.id.toLowerCase() === groupFolderId.toLowerCase()
    ) {
        // Do not perform the rest of selecting group folder logic when
        // user navigates to the node with the same id
        state.selectedNode.treeType = treeType;
        state.selectedNode.groupId = groupId;
        state.selectedNode.id = groupFolderId;
    } else if (
        currentNode.type === FolderForestNodeType.GroupFolder &&
        currentNode.groupId &&
        currentNode.groupId.toLowerCase() === groupId.toLowerCase() &&
        currentNode.id &&
        currentNode.id.toLowerCase() !== groupFolderId.toLowerCase()
    ) {
        // Same group different folder
        selectGroupFolderInternal(groupId, groupFolderId, treeType);
    } else if (
        // Different group different folder
        currentNode.type === FolderForestNodeType.GroupFolder &&
        currentNode.groupId &&
        currentNode.groupId.toLowerCase() !== groupId.toLowerCase()
    ) {
        // Switch group
        await lazySelectGroup.importAndExecute(groupId, GROUPS_FOLDERS_TREE_TYPE);
        selectGroupFolderInternal(groupId, groupFolderId, treeType);
    } else {
        await lazySelectGroup.importAndExecute(groupId, GROUPS_FOLDERS_TREE_TYPE);
        selectGroupFolderInternal(groupId, groupFolderId, treeType);
    }

    onAfterSelectingNode();
});
